<template>
  <l-map :center="mapCenter" :zoom="13" style="height: 80vh">
    <l-tile-layer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    ></l-tile-layer>
    <l-marker
      v-for="(user, index) in dashboards"
      :key="`k-${index}`"
      :lat-lng="[user.latitude, user.longitude]"
      :icon="getIcon(user.plant)"
    >
      <l-tooltip ref="mapTooltip" :options="{ permanent: permanentTooltip }">
        <div class="text-lg">
          {{ `${user.plant}` }}
        </div>
        <div>
          {{ `${user.dman} : ${user.dmanName}` }}
        </div>
        <div>{{ dayjs(user.timeStamp).fromNow() }}</div>
      </l-tooltip>
    </l-marker>
  </l-map>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from "vue";
import { LMap, LTileLayer, LMarker, LTooltip } from "@vue-leaflet/vue-leaflet";
import { DashboardView } from "@/types";
import { usePlugin } from "@/plugins";
import { DivIcon } from "leaflet";

export default defineComponent({
  name: "DashboardMap",
  components: { LMap, LTileLayer, LMarker, LTooltip },
  props: {
    dashboards: {
      type: Array as PropType<DashboardView[]>,
      required: true,
    },
    salesOfficesColor: {
      type: Object as PropType<{ [key: string]: string }>,
      required: true,
    },
  },
  setup(props) {
    const { error, rainbow, dayjs } = usePlugin();

    const avg = (array: number[]) =>
      array.reduce((a, b) => a + b) / array.length;

    const mapCenter = computed(() => {
      const latitudes = props.dashboards.map((x) => x.latitude);
      const longitudes = props.dashboards.map((x) => x.longitude);

      if (latitudes.length === 0 || longitudes.length === 0) return [6, 101];

      return [latitudes[0], longitudes[0]];
    });

    const permanentTooltip = ref(false);

    const getIcon = (salesOffice: string | null): DivIcon => {
      const html = `
      background-color: ${props.salesOfficesColor[salesOffice ?? "N/A"]};

      width: 1.5rem;
      height: 1.5rem;
      display: block;
      left: -0.75rem;
      top: -0.75rem;
      position: relative;
      border-radius: 1.5rem 1.5rem 0;
      transform: rotate(45deg);
      border: 1px solid #000000`;
      const icon = new DivIcon({
        iconAnchor: [0, 16],
        popupAnchor: [0, 0],
        html: `<span style="${html}" />`,
      });
      return icon;
    };

    return { mapCenter, getIcon, dayjs, permanentTooltip };
  },
});
</script>

<style></style>
